import { Injectable } from '@angular/core'
import { Action, select, Store } from '@ngrx/store'
import { GbBaseFacade } from 'libs/shared/data-access-core/src/lib/+state/gb-base-facade-interface'
import * as ActivityFeedPostsSelectors from './activity-feed-posts.selectors'

@Injectable({
  providedIn: 'root',
})
export class ActivityFeedPostsFacade implements GbBaseFacade {
  /**
   * Combine pieces of state using createSelector,
   * and expose them as observables through the facade.
   */
  loaded$ = this.store.pipe(select(ActivityFeedPostsSelectors.getActivityFeedPostsLoaded))
  allActivityFeedPosts$ = this.store.pipe(select(ActivityFeedPostsSelectors.getAllActivityFeedPosts))
  selectedActivityFeedPosts$ = this.store.pipe(select(ActivityFeedPostsSelectors.getSelected))
  next$ = this.store.pipe(select(ActivityFeedPostsSelectors.getActivityFeedPostsNext))

  activePage$ = this.store.pipe(select(ActivityFeedPostsSelectors.getActivePage))

  count$ = this.store.pipe(select(ActivityFeedPostsSelectors.getCount))

  newActivityFeedPost$ = this.store.pipe(select(ActivityFeedPostsSelectors.newActivityFeedPost))

  getSubmitting$ = this.store.pipe(select(ActivityFeedPostsSelectors.getSubmitting))

  constructor(private readonly store: Store) {}

  dispatch(action: Action): void {
    this.store.dispatch(action)
  }
}
